import React from 'react';
import styles from './Cienie.css';
import cienieImg from '../../../assets/cienie.jpg';
import spacer from '../../../assets/spacer.png';
import CallToActionBtn from "../../CallToActionBtn/CallToActionBtn";

const text = {
    "subtitle": "Czarna magia budzi się, gdy nienawiść rządzi ludzką ręką",
    "desc1": "Czarny kryminał z mocnymi elementami horroru. Inspiracją do powstania audiobooka było opowiadanie grozy H.P. Lovecrafta \"Zew Cthulhu\". Wizje niczym z horroru przeplatają się tu z całkiem realnymi, choć koszmarnymi, zbrodniczymi rytuałami."
};

const Cienie = (props) => (
    <div className={styles.mainDiv}>
        <img src={cienieImg} className={styles.mainImg} alt="Cienie Nowego Orleanu"/>
        <p className={styles.subtitle}>{text["subtitle"]}</p>
        <img src={spacer} className={styles.spacer} alt="spacer"/>
        <p className={styles.text}>{text["desc1"]}</p>
        <img src={spacer} className={styles.spacer} alt="spacer"/>
        <CallToActionBtn audioteka={true} />
    </div>
);

export default Cienie;


// WEBPACK FOOTER //
// ./src/components/Mobile/Cienie/Cienie.js